export default __webpack_public_path__ + "static/media/Mobile.2f4d1e20.svg";